import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface ChangeChannelDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

function ChangeChannelDialog({ open, onCancel, onConfirm }: ChangeChannelDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
        <WarningAmberIcon sx={{ color: '#fd7e14' }} />
        <Typography variant="subtitle1" fontWeight={700}>
          Changer de canal
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: '0.9rem', color: 'text.primary' }}>
          Attention, changer de canal va supprimer les données de création et d'offre(s) déjà renseignées pour ce canal. Voulez-vous continuer ?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 0 }}>
        <Button
          onClick={onCancel}
          sx={{ textTransform: 'none', color: '#6c757d' }}
        >
          Annuler
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#dc3545', '&:hover': { backgroundColor: '#dc3545', opacity: 0.9 } }}
        >
          Changer de canal
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ChangeChannelDialog;
